<template>
  <div class="overlay" :class="{ visible: internalVisible, shown }">
    <div class="dialog">
      <h3 class="title">Please think about your decision...</h3>
      <div class="content"></div>
      <div class="buttons-container">
        <button class="a-button" @click="onAccept('A')">Upload Drone Data</button>
        <button class="b-button" @click="onAccept('B')">Dismiss</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DecisionDialog",
  props: {
    visible: Boolean,
    gameStateKey: String,
  },
  data() {
    return {
      internalVisible: this.visible,
      shown: this.visible,
    };
  },
  computed: {},
  methods: {
    onAccept(side) {
      this.internalVisible = false;

      setTimeout(() => {
        this.shown = false;
        this.$emit("accept", side);

        this.$nextTick(() => this.syncVisible(this.visible));
      }, 250);
    },
    syncVisible(value) {
      if (value) {
        this.shown = true;
        setTimeout(() => {
          this.internalVisible = true;
        }, 50);
      } else {
        this.internalVisible = false;
        setTimeout(() => {
          this.shown = false;
        }, 250);
      }
    },
  },
  watch: {
    visible(value) {
      this.syncVisible(value);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables";

.overlay {
  background-color: rgba(black, 0.5);

  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 10;

  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  transition-property: opacity;
  transition-duration: 250ms;
  transition-timing-function: ease-in-out;

  opacity: 0;

  &.shown {
    display: flex;
  }

  &.visible {
    opacity: 1;

    .dialog {
      transform: none;
    }
  }

  .dialog {
    width: 300px;

    padding: 16px;

    border-radius: 6px;

    background-color: white;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);

    transition-property: transform;
    transition-duration: 250ms;
    transition-timing-function: ease-in-out;

    transform: scale(0);

    .title {
      color: $primary-text-black;
    }

    .content {
      width: 100%;
    }

    .buttons-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: stretch;

      margin-top: 32px;

      button {
        background: none;
        border: none;
        padding: 0px;
        color: $primary-text-white;
        user-select: none;
        cursor: pointer;
      }

      .a-button {
        background-color: #2962ff;
        text-transform: uppercase;
        padding: 16px;
        margin-right: 8px;
        width: 100%;
        border-radius: 6px;

        transition-property: background-color;
        transition-duration: 100ms;
        transition-timing-function: ease-in-out;

        font-size: 1rem;

        &:hover {
          background-color: mix(#2962ff, black, 90%);
        }

        &:active {
          background-color: mix(#2962ff, black, 80%);
        }
      }

      .b-button {
        background-color: #d50000;
        text-transform: uppercase;
        padding: 16px;
        margin-left: 8px;
        width: 100%;
        border-radius: 6px;

        transition-property: background-color;
        transition-duration: 100ms;
        transition-timing-function: ease-in-out;

        font-size: 1rem;

        &:hover {
          background-color: mix(#d50000, black, 90%);
        }

        &:active {
          background-color: mix(#d50000, black, 80%);
        }
      }
    }
  }
}
</style>
